import angular from 'angular';
import FileService from './file.service';

/* @ngInject */
export default angular.module('autoboard.storage', [FileService])
  .name;
